import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { UserStatusProvider } from './contexts/UserStatusContext';
import { NavigationProvider } from './contexts/NavigationContext';
import { KnowledgeBaseProvider } from './contexts/KnowledgeBaseContext';
import { PortalProvider } from './contexts/PortalContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { RepositoryProvider } from './data/repositories';
import { ErrorBoundary } from './components';
import { AppRoutes } from './routes/AppRoutes';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <RepositoryProvider>
        <BrowserRouter>
          <AuthProvider>
            <ThemeProvider>
              <PortalProvider>
                <NotificationProvider>
                  <UserStatusProvider>
                    <NavigationProvider>
                      <KnowledgeBaseProvider>
                        <AppRoutes />
                      </KnowledgeBaseProvider>
                    </NavigationProvider>
                  </UserStatusProvider>
                </NotificationProvider>
              </PortalProvider>
            </ThemeProvider>
          </AuthProvider>
        </BrowserRouter>
      </RepositoryProvider>
    </ErrorBoundary>
  );
}

export default App;
